import About from '../pages/About/about.vue';
import BlogListPage from '../pages/BlogListPage/blog.list.page.vue';
import BlogDetail from '../pages/BlogDetailPage/blog.detail.page.vue';
import PropertyListPage from '../pages/PropertyListPage/property.list.page.vue';
import PropertyDetailPage from '../pages/PropertyDetailPage/property.detail.page.vue';
import DailyReportPage from '../pages/DailyReportPage/daily.report.page.vue';
import AboutAgent from '../pages/AboutAgent/about.agent.vue';
import CommunityMarketTrendPage from '../pages/CommunityMarketTrendPage/community.market.trend.page.vue';

export function rifoBlogRoutesFactory() {
    return [
        { component: CommunityMarketTrendPage, path: '/community-markettrend' },
        { component: About, path: '/about' },
        { component: BlogListPage, path: '/blogs' },
        { component: PropertyListPage, path: '/listings' },
        { component: BlogDetail, path: '/blog/:blogid' },
        { component: PropertyDetailPage, path: '/listing/:listingid' },
        { component: DailyReportPage, path: '/daily-report' },
        { component: AboutAgent, path: '/about-agent' },
    ];
}
